import { useQuery } from '@tanstack/react-query';

import { dynaVaultsAPI, TokenPricesResponse } from 'api/DynaVaultsAPI';
import { QueryOptions } from 'utils/useQueryUtils';
import { queryKeys } from 'structure/pv2/vault/configs/queryKeys';

const EMPTY_PRICES: TokenPricesResponse = {
  prices: {},
  updatedAt: '',
};

export const getTokenPrice = (
  data: TokenPricesResponse | undefined,
  coingeckoId: string | undefined
): number => {
  if (!coingeckoId || !data) {
    return 0;
  }

  return data.prices[coingeckoId] || 0;
};

export const useTokenPrices = (params: QueryOptions = {}) => {
  const { query } = params;

  return useQuery({
    queryKey: queryKeys.tokenPrices(),
    queryFn: async (): Promise<TokenPricesResponse> => {
      try {
        return await dynaVaultsAPI.loadTokenPrices();
      } catch {
        return EMPTY_PRICES;
      }
    },
    ...query,
  });
};
